'use strict';

var App = require('app');
var AppState = require('app_state');
var HomeView = require('components/home/views/home_view');
var InfoView = require('components/account/views/info_dialog_view');
var CommonViews = require('components/common/views');
var i18n = require('utils/i18n');
var Cookie = require('utils/cookie');
var Messages = require('utils/messages');
var Consts = require('consts');

var HomeController = {};

HomeController.showBaseLayout = function (options) {
    // request user information -> might trigger "auto login"
    var user = App.request('user:me');
    var self = this;
    $.when(user).done(function (user) {
        AppState.initUser(user);

        if (AppState.user === undefined) {
            App.trigger('login:show');
            return;
        }

        if (!Cookie.get('initialized') || Cookie.get('initialized') === '-1') {
            self.showInfoScreen(user.getPreferences());
            Cookie.set('initialized', 1);
        }

        // user is logged in -> request remaining infos
        var style = App.request('user:style');
        var permissions = App.request('permissions:me', options.deviceID);

        $.when(style, permissions).done(function (style, permissions) {
            if (permissions !== undefined) {
                if (permissions.data) {
                    permissions = permissions.data;
                } else {
                    // access denied: go to homepage
                    App.trigger('home:show');
                    return;
                }
            }

            if (style) AppState.style = style.get('style');

            if (AppState.layout === undefined || AppState.layout.isDestroyed) {
                AppState.layout = new HomeView({ model: AppState.user });
            } else {
                AppState.layout.model = AppState.user;
            }
            App.main.show(AppState.layout);

            // execute callback -> initialize content area
            options.cb(permissions);

            App.forceResize();
        });
    });
};

HomeController.showInfoScreen = function (config) {
    if (!config) {
        // initialize default configuration
        config = {
            messages: true,
            updates: true,
            app_version: AppState.version,
        };
        AppState.saveInfoConfig(config);

        // first time user -> also show welcome message
        config.welcome = true;
    }

    // collect infos ..
    var infoRequests = [undefined, undefined, undefined];

    // .. message
    if (config.messages && AppState.message != undefined) {
        infoRequests[0] = $.Deferred();
        infoRequests[0].resolve({
            id: 'messages',
            color: 'danger',
            title: AppState.message.title,
            summary: AppState.message.summary,
            details: AppState.message.details,
        });
    }

    // .. welcome
    if (config.welcome) {
        infoRequests[1] = Messages.getInfo('welcome');
    }

    // .. updates
    if (config.updates && !config.welcome && config.app_version != AppState.version) {
        infoRequests[2] = Messages.getInfo('update_v' + AppState.version);

        config.app_version = AppState.version;
        AppState.saveInfoConfig(config);
    }

    $.when(infoRequests[0], infoRequests[1], infoRequests[2]).done(function (m, w, u) {
        // prepare infos (in the correct order)
        var infos = [];

        // 1. welcome message
        if (w) {
            infos.push({
                id: 'welcome',
                color: 'inverse',
                title: w.title,
                summary: w.summary,
                details: w.details,
            });
        }

        // 2. important application message
        if (m) {
            infos.push(m);
        }

        // 3. inform about updates
        if (u) {
            infos.push({
                id: 'updates',
                color: 'info',
                title: u.title,
                footer: u.footer,
                summary: u.summary,
                details: u.details,
            });
        }

        if (infos.length > 0) {
            App.showModal(new InfoView({ want: config, infos: infos }));
        }
    });
};

HomeController.showMobileWizard = function () {
    App.main.show(new CommonViews.Loading());

    var self = this;
    var user = App.request('user:me');

    $.when(user).done(function (user) {
        self.showBaseLayout({
            cb: function () {
                App.trigger('sidebar:default');
                var ProfileController = require('components/profile/profile_controller');
                ProfileController.showPhoneDialog();
            },
        });
    });
};

HomeController.showHome = function (contextData) {
    App.main.show(new CommonViews.Loading());

    var self = this;
    var user = App.request('user:me');

    $.when(user).done(function (user) {
        AppState.initUser(user);

        if (AppState.user === undefined) {
            App.trigger('login:show', contextData);
            return;
        }

        var categoryDeviceCount = AppState.getAvailableCategoryCount();
        var hasDeviceAccess = _.keys(categoryDeviceCount).length > 0;
        var hasDashboardAccess = AppState.dashboardAvailable();

        // three possible cases ...
        // ... (1) no devices available, but dashboard access possible
        if (!hasDeviceAccess && hasDashboardAccess) {
            App.trigger('dashboard:show');
            return;
        }

        // .. (2) devices available, but dashboard must be shown at startup
        var dashboard = AppState.user.get('features').dashboard || {};
        if (dashboard.show_on_start && hasDashboardAccess) {
            App.trigger('dashboard:show');
            return;
        }

        // .. (3) do not show dashboard - device list or "no devices available" hint
        if (hasDeviceAccess) {
            // devices available -> redirect to "longest" device list
            var maxCount = -1;
            var route = '';

            _.each(Consts.CategoryData, function (r, c) {
                var count = categoryDeviceCount[Consts.Category[c]];
                if (count >= maxCount) {
                    maxCount = count;
                    route = r.category;
                }
            });

            route = route || 'gateway';

            App.trigger(route + ':show');
        } else {
            self.showBaseLayout({
                cb: function () {
                    App.trigger('sidebar:default');

                    var viewOptions = {
                        title: i18n.TR('Keine Geräte gefunden'),
                        titleID: 'no-devices-found-heading',
                        text: i18n.TR('Momentan können Sie auf keine Geräte zugreifen.'),
                    };

                    if (AppState.hasCompanyPermission(Consts.PermissionsCompany.AddDevices)) {
                        _.extend(viewOptions, {
                            action_label: i18n.TR('Gateway registrieren'),
                            action_cb: function () {
                                // lazy import - prevent require-cycles
                                var Controller = require('components/devices/devices_controller');
                                Controller.addDevice();
                            },
                        });
                    }

                    App.showContentView(new CommonViews.Message(viewOptions));
                },
            });
        }
    });
};

module.exports = HomeController;
